const patchOperation = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    REPLACE: 'REPLACE',
};

export default patchOperation;
